import { render, staticRenderFns } from "./WapPage.vue?vue&type=template&id=7f95cc14&scoped=true&"
import script from "./WapPage.vue?vue&type=script&lang=js&"
export * from "./WapPage.vue?vue&type=script&lang=js&"
import style0 from "./WapPage.vue?vue&type=style&index=0&id=7f95cc14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f95cc14",
  null
  
)

export default component.exports